var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "hearing-aid-sales__member-report page__container--no-padding"
    },
    [
      _c("Filters"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "sales-report-body",
          attrs: { id: "sales-report__affix-anchor" }
        },
        [
          _c("ReportNavigation"),
          _vm._v(" "),
          _vm.filtersChanged || _vm.loaders.sections
            ? _c("div", { staticClass: "fuel-utilization__no-data" }, [
                _vm.filtersChanged
                  ? _c("div", [
                      _c("h3", [_vm._v("NOTICE:")]),
                      _vm._v(
                        "\n        Please run a new report to apply the current filter settings.\n      "
                      )
                    ])
                  : _vm.loaders.sections && !_vm.globalLoading
                  ? _c(
                      "div",
                      [
                        _c("MoonLoader", {
                          attrs: { size: "75px", color: "#ffffff" }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.filtersChanged
            ? [
                _c("transition", { attrs: { name: "bounce" } }, [
                  _vm.displayTotals && !_vm.loaders.totals
                    ? _c(
                        "div",
                        { staticClass: "sales-report__section" },
                        [
                          _c("a", {
                            staticClass: "sales-nav__anchor",
                            attrs: { id: "a_Totals" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "sales-report-body__header-section",
                              attrs: { id: "summary-title" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "sales-report-body__section-title"
                                },
                                [_vm._v("Overall Summary")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("ReportTotals", {
                            attrs: {
                              title: "Report Totals",
                              "entity-data": _vm.contents
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("transition", { attrs: { name: "fade" } }, [
                  _vm.displayVendors && !_vm.loaders.totalsByVendor
                    ? _c(
                        "div",
                        { staticClass: "sales-report__section" },
                        [
                          _c("a", {
                            staticClass: "sales-nav__anchor",
                            attrs: { id: "a_Vendors" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "sales-report-body__header-section"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "sales-report-body__section-title"
                                },
                                [_vm._v("Vendor Summary")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("ReportVendors")
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("transition", { attrs: { name: "fade" } }, [
                  _vm.displayStats && !_vm.loaders.statsNational
                    ? _c(
                        "div",
                        { staticClass: "sales-report__section" },
                        [
                          _c("a", {
                            staticClass: "sales-nav__anchor",
                            attrs: { id: "a_Stats" }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "sales-report-body__header-section"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "sales-report-body__section-title"
                                },
                                [_vm._v("Statistics")]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("ReportStats")
                        ],
                        1
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.displayLocations && !_vm.loaders.locations
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "sales-report__section sales-report__section--location-summary"
                      },
                      [
                        _c("a", {
                          staticClass: "sales-nav__anchor",
                          attrs: { id: "a_LocationSummary" }
                        }),
                        _vm._v(" "),
                        _vm._m(0),
                        _vm._v(" "),
                        _c("ReportLocationSummary")
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.displayLocations && !_vm.loaders.locations
                  ? _c(
                      "div",
                      { staticClass: "sales-report__section" },
                      [
                        _c("a", {
                          staticClass: "sales-nav__anchor",
                          attrs: { id: "a_Locations" }
                        }),
                        _vm._v(" "),
                        _vm._m(1),
                        _vm._v(" "),
                        _vm._l(_vm.contents.locations, function(
                          location,
                          index
                        ) {
                          return _c("ReportLocation", {
                            key: "location-" + index,
                            attrs: {
                              "entity-data": location,
                              "active-filters": {
                                location_ids: [location.location_id]
                              }
                            }
                          })
                        })
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.displayPractices && !_vm.loaders.businesses
                  ? _c(
                      "div",
                      { staticClass: "sales-report__section" },
                      [
                        _c("a", {
                          staticClass: "sales-nav__anchor",
                          attrs: { id: "a_Practices" }
                        }),
                        _vm._v(" "),
                        _vm._m(2),
                        _vm._v(" "),
                        _vm._l(_vm.contents.businesses, function(
                          business,
                          index
                        ) {
                          return _c("ReportTotals", {
                            key: "practice-" + index,
                            attrs: {
                              "entity-data": business,
                              "active-filters": {
                                business_ids: [business.business_id]
                              }
                            }
                          })
                        })
                      ],
                      2
                    )
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "css-grid sales-report-body__header-section" },
      [
        _c("div", { staticClass: "sales-report-body__section-title" }, [
          _vm._v("Location Summary")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "css-grid sales-report-body__header-section" },
      [
        _c("div", { staticClass: "sales-report-body__section-title" }, [
          _vm._v("Sales by Location")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "css-grid sales-report-body__header-section" },
      [
        _c("div", { staticClass: "sales-report-body__section-title" }, [
          _vm._v("Sales by Practice")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }